<template>
  <div class="independent-wrapper">
    <div class="content">
      <div class="title">
        <span class="border"></span>
        <i class="el-icon-location-outline"></i> 商城管理 > 城代审批
      </div>
      <div class="contentLeft">
        <div class="con">
          <!-- Tab 切换 -->
          <div class="toolbar">
            <el-radio-group v-model="activeTab" @change="handleTabChange">
              <el-radio-button label="pending">待审批</el-radio-button>
              <el-radio-button label="all">全部记录</el-radio-button>
            </el-radio-group>
          </div>

          <!-- 申请表格 -->
          <div class="table-con consiliaTable">
            <el-table
              :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
              tooltip-effect="dark"
              style="width: 100%"
              :data="tableData"
              v-loading="loading"
            >
              <el-table-column align="center" label="ID" prop="id" width="60"></el-table-column>
              <el-table-column align="center" label="申请人" width="120">
                <template #default="{ row }">
                  <div>{{ row.name || '-' }}</div>
                  <div style="font-size: 12px; color: #999;">{{ row.phone }}</div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="意向城市" prop="intendedCityName" width="110">
                <template #default="{ row }">{{ row.intendedCityName || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="联系地址" prop="address" min-width="160" show-overflow-tooltip>
                <template #default="{ row }">{{ row.address || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="推荐城代" width="140">
                <template #default="{ row }">
                  <div>{{ row.referrerName || '-' }}</div>
                  <div style="font-size: 12px; color: #999;">
                    {{ row.referrerInviteCode || '' }}<span v-if="row.referrerCityName"> · {{ row.referrerCityName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="状态" width="90">
                <template #default="{ row }">
                  <el-tag :type="statusType(row.status)" size="small">{{ statusName(row.status) }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="核定城市" width="100">
                <template #default="{ row }">{{ row.auditCityName || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="驳回原因" prop="rejectReason" min-width="130" show-overflow-tooltip>
                <template #default="{ row }">{{ row.rejectReason || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="申请时间" width="160">
                <template #default="{ row }">{{ row.applyTime || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="130" v-if="activeTab === 'pending'">
                <template #default="{ row }">
                  <span class="editor" @click="handleApprove(row)">通过</span>
                  <span class="del" @click="handleReject(row)">驳回</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <!-- 审批通过弹窗（核定城市） -->
    <el-dialog title="审批通过 · 核定城市" v-model="approveDialogVisible" width="420px" center class="cityagent-dialog">
      <el-form label-width="90px">
        <el-form-item label="申请人">
          <span>{{ currentRow.name }}（{{ currentRow.phone }}）</span>
        </el-form-item>
        <el-form-item label="意向城市">
          <span>{{ currentRow.intendedCityName || '-' }}</span>
        </el-form-item>
        <el-form-item label="核定城市">
          <el-input v-model="approveForm.cityName" placeholder="平台核定开通城市名称（如 杭州市）"></el-input>
        </el-form-item>
        <el-form-item label="城市编码">
          <el-input v-model="approveForm.cityCode" placeholder="选填，城市编码"></el-input>
        </el-form-item>
        <div class="dialog-tip">同一城市仅允许一名在职城市代理，通过后将为申请人开通城代账户并建立推荐关系。</div>
      </el-form>
      <template #footer>
        <el-button @click="approveDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmApprove" :loading="approving">确定通过</el-button>
      </template>
    </el-dialog>

    <!-- 驳回原因弹窗 -->
    <el-dialog title="驳回城代申请" v-model="rejectDialogVisible" width="400px" center class="cityagent-dialog">
      <el-form label-width="80px">
        <el-form-item label="驳回原因">
          <el-input v-model="rejectReason" type="textarea" :rows="3" placeholder="请输入驳回原因"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="rejectDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmReject" :loading="rejecting">确定驳回</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axiosconf from '../../api/axiosconf'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      activeTab: 'pending',
      // 审批通过
      approveDialogVisible: false,
      currentRow: {},
      approveForm: { cityName: '', cityCode: '' },
      approving: false,
      // 驳回
      rejectDialogVisible: false,
      rejectReason: '',
      rejectingId: null,
      rejecting: false,
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    statusName(status) {
      const map = { 0: '待审批', 1: '已通过', 2: '已驳回' }
      return map[status] || '-'
    },
    statusType(status) {
      const map = { 0: 'warning', 1: 'success', 2: 'danger' }
      return map[status] || 'info'
    },
    handleTabChange() {
      this.fetchList()
    },
    async fetchList() {
      this.loading = true
      try {
        const params = this.activeTab === 'pending' ? { status: 0 } : {}
        const res = await axiosconf.applicationJsonGet('/mall/admin/cityAgentApply/list', params)
        if (res.data && res.data.code === 0) {
          const data = res.data.data
          this.tableData = data.records || data || []
        }
      } catch (e) {
        console.error('获取城代申请列表失败', e)
      } finally {
        this.loading = false
      }
    },
    handleApprove(row) {
      this.currentRow = row
      this.approveForm = {
        cityName: row.intendedCityName || '',
        cityCode: row.intendedCityCode || ''
      }
      this.approveDialogVisible = true
    },
    async confirmApprove() {
      if (!this.approveForm.cityName.trim()) {
        this.$message.warning('请填写核定城市名称')
        return
      }
      this.approving = true
      try {
        const res = await axiosconf.applicationJson(`/mall/admin/cityAgentApply/approve/${this.currentRow.id}`, {
          cityName: this.approveForm.cityName.trim(),
          cityCode: this.approveForm.cityCode.trim()
        })
        if (res.data && res.data.code === 0) {
          this.$message.success('审批通过，城市代理已开通')
          this.approveDialogVisible = false
          this.fetchList()
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      } catch (e) {
        this.$message.error('请求失败')
      } finally {
        this.approving = false
      }
    },
    handleReject(row) {
      this.rejectingId = row.id
      this.rejectReason = ''
      this.rejectDialogVisible = true
    },
    async confirmReject() {
      if (!this.rejectReason.trim()) {
        this.$message.warning('请输入驳回原因')
        return
      }
      this.rejecting = true
      try {
        const res = await axiosconf.applicationJson(`/mall/admin/cityAgentApply/reject/${this.rejectingId}`, {
          reason: this.rejectReason
        })
        if (res.data && res.data.code === 0) {
          this.$message.success('已驳回')
          this.rejectDialogVisible = false
          this.fetchList()
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      } catch (e) {
        this.$message.error('请求失败')
      } finally {
        this.rejecting = false
      }
    },
  }
}
</script>

<style scoped>
.independent-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.content {
  padding: 20px;
}
.title {
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}
.title .border {
  display: inline-block;
  width: 3px;
  height: 14px;
  background: #679FF6;
  margin-right: 8px;
  vertical-align: middle;
}
.toolbar {
  margin-bottom: 16px;
}
.editor {
  color: #679FF6;
  cursor: pointer;
  margin-right: 10px;
}
.del {
  color: #f56c6c;
  cursor: pointer;
}
.dialog-tip {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
  padding: 0 0 4px 90px;
}
</style>
<style>
.cityagent-dialog .el-dialog__body { padding: 20px 24px 4px; }
</style>
